export default __webpack_public_path__ + "static/media/logo-gestinet.70e686c8.png";